var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({staticClass:"base-button",class:_setup.baseButtonClasses,attrs:{"aria-label":_vm.accessibilityLabel,"disabled":_vm.isDisabled,"type":[_vm.isSubmit ? 'submit' : '']}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }